<template>
    <div>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list>
        <v-list-item
          v-for="item in drawerItems"
          :key="item.title"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app dark>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-btn icon large>
        <v-avatar size="32px" item>
          <v-img :src="avatarImg" alt="Vuetify" />
        </v-avatar>
      </v-btn>
    </v-app-bar>
    </div>
</template>

<script>
export default {
  name: 'AppHeader',
  data: () => ({
    drawerItems: [
      { title: 'Activity', icon: 'mdi-bell' }
    ],
    avatarImg: require('@/assets/img/5s.png'),
    dialog: false,
    drawer: null
  })
}
</script>
